/**
 * ROUTE actions from the copilot: `{type: "ROUTE", route, path, params, label, handoffMessage?}`.
 *
 * The copilot builds `path` from its route map, but it is still data from the network, so
 * the console only follows same-origin, in-app paths.
 */
import { matchPath } from 'react-router-dom';
import { ACCOUNT_SCOPE_PREFIX } from '../api/copilot-api';

const MAX_PATH = 512;

export function isSafeInternalPath(path) {
    if (typeof path !== 'string' || !path.startsWith('/') || path.length > MAX_PATH) return false;
    if (path.startsWith('//') || path.includes('\\')) return false; // protocol-relative / backslash tricks
    for (let i = 0; i < path.length; i += 1) {
        const code = path.charCodeAt(i);
        if (code < 0x20 || code === 0x7f) return false; // control characters
    }
    try {
        // Resolves against the current origin: anything that changes origin is rejected.
        return new URL(path, window.location.origin).origin === window.location.origin;
    } catch (_) {
        return false;
    }
}

export function isRouteAction(action) {
    return Boolean(action && typeof action === 'object' && action.type === 'ROUTE');
}

/** The copilot scope a path belongs to: its application, or the account. */
export function scopeForPath(path, accountId) {
    const match = matchPath({ path: '/app/:appId/*' }, path) || matchPath({ path: '/app/:appId' }, path);
    if (match?.params?.appId) return match.params.appId;
    return accountId ? `${ACCOUNT_SCOPE_PREFIX}${accountId}` : null;
}
